<!--DropSelecaoData.svelte-->
<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Loading from "./Loading.svelte";
  import Conexoes from "../Classes/Conexoes";
  import Constantes from "../Classes/Constantes";
  import { Card, Paper } from "@svelteuidev/core";
    import consolar from "../Classes/Consolar";

  export let config;
  export let data;
  export let saida = [];
  const dispatch = createEventDispatcher();
  let api;
  let query_code;
  let salvarEmLista;
  let tituloTextoLivre;
  let campos_pesquisaveis;
  let primeiroDisparo = false;
  let colunas_exibidas;
  let coluna_saida;
  let termo_pesquisa;
  let conexao = new Conexoes();
  let dados = [];
  export let showModal = false;
  let keys = [];
  export let selectedRows = [];
  let selecionado = [];
  let page = 0;
  let size = 10;
  let carregando = false;
  let IgnorarId = true;
  let timer;
  let titulo = "Selecione os dados";
  let pararCarregar = false;
  let modo = "lista"; // Variável para controlar o modo
  let textoLivre = ""; // Variável para armazenar o texto livre
  let obs;
  function Pesquisar() {
    pararCarregar = false;
    carregando = true;
    clearTimeout(timer);

    timer = setTimeout(() => {
      dados = [];
      page = 0;
      pegaDados();
      carregando = false;
    }, 2000);
  }

  async function pegaDados() {
    carregando = true;
    let parametro_adicional = "";
    if (config.parametro_adicional) {
      parametro_adicional = config.parametro_adicional;
    }
    console.log("paramentro ad", parametro_adicional);
    let resultado = await conexao.conecta(api, {
      query_code: query_code,
      posicao: page,
      tamanho: size,
      campos_pesquisaveis: campos_pesquisaveis,
      termo_pesquisa: termo_pesquisa,
      parametro_adicional: parametro_adicional,
    });
    carregando = false;
    if (resultado && resultado.length == 0) {
      pararCarregar = true;
      return;
    }
    dados = [...dados, ...resultado];
    if (dados.length > 0) {
      keys = Object.keys(dados[0]);
    }
  }

  function IniciarParametros() {
    api = config.api;
    query_code = config.query_code;
    campos_pesquisaveis = config.campos_pesquisaveis;
    colunas_exibidas = config.colunas_exibidas;
    coluna_saida = config.coluna_saida;
    titulo = config.titulo;

    // Se houver um texto livre pré-preenchido, ativa o modo texto livre
    if (selectedRows.length > 0 && selectedRows[0].texto_livre) {
      modo = "texto_livre";
      textoLivre = selectedRows[0].texto_livre;
    }
  }

  onMount(async () => {
    await config;
    IniciarParametros();
  
      pegaDados();
    
  });

  function closeModal() {
    showModal = false;
  }

  function switchMode(novoModo) {
    modo = novoModo;
    clearSelectedRowsSemClose();
  }
  function confirmarTextoLivre() {
    if (textoLivre) {
      const textoLivreSaida = {
        texto_livre: textoLivre,
        salvar_em_lista: salvarEmLista ? 1 : 0, // Adiciona a chave salvar_em_lista
        titulo: tituloTextoLivre,
        observacao: obs
      };

      saida = [textoLivreSaida];
      dispatch("selecionado", {
        dado: textoLivreSaida,
        data: data,
        selectedRows: [textoLivreSaida],
      });
    } else {
      saida = "";
      clearSelectedRows();
    }

    closeModal();
  }

  function toggleRowSelection(dado, idx) {
    const index = selectedRows.findIndex(
      (row) => JSON.stringify(row) === JSON.stringify(dado),
    );
    if (index === -1) {
      if (config.selecaoUnica) {
        selectedRows = [dado];
      } else {
        selectedRows = [...selectedRows, dado];
      }
    } else {
      selectedRows = selectedRows.filter(
        (row) => JSON.stringify(row) !== JSON.stringify(dado),
      );
    }

    saida = selectedRows.map((row) => row[coluna_saida]);
    isSelected(idx);
    dispatch("selecionado", {
      dado: dado,
      data: data,
      selectedRows: selectedRows,
    });
    if (config.selecaoUnica) {
      closeModal();
    }
  }

  function isSelected(idx) {
    if (!selecionado[idx]) {
      selecionado[idx] = "table-secondary";
    } else {
      selecionado[idx] = "";
    }
  }

  function removeSelectedRow(idx) {
    selectedRows.splice(idx, 1);
    selectedRows = [...selectedRows];
    selecionado[idx] = "";
  }

  function clearSelectedRows() {
    selectedRows = [];
    selecionado = [];
    dispatch("selecionado", {
      dado: "",
      data: data,
      selectedRows: selectedRows,
    });
    closeModal();
  }

function clearSelectedRowsSemClose() {
    selectedRows = [];
    selecionado = [];
    textoLivre="";
    tituloTextoLivre="";
    salvarEmLista=0;
    dispatch("selecionado", {
      dado: "",
      data: data,
      selectedRows: selectedRows,
    });
    
  }
  function handleScroll(event) {
    consolar.log('handle');
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - 50 && !carregando) {
      if (!pararCarregar) {
        page = page + size;
        pegaDados();
      }
    }
  }

  function ColunasExibidas(row) {
    let saida = "";

    colunas_exibidas.forEach((elemento) => {
      saida += row[elemento] + " - ";
    });

    saida = rtrimChar(saida, " - ") + "...";
    return saida;
  }

  function rtrimChar(str, char) {
    if (str.endsWith(char)) {
      return str.slice(0, -1);
    }
    return str;
  }
  function ConfirmarLista() {
    if (selectedRows.length > 0) {
      dispatch("selecionado", { dado: selectedRows, data: data, selectedRows });
    }

    closeModal();
  }
</script>

<div class="container">
  <Paper>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="data-input" class="form-label">{titulo}</label>
          <input
            id="data-input"
            type="text"
            class="form-control disabled-input"
            readonly
            placeholder="Selecione os dados"
            on:click={() => (showModal = true)}
          />
        </div>
      </div>
    </div>
    <div
      class="selected-rows-container"
      style="max-height: 300px; overflow-y: auto;"
    ></div>
  </Paper>
</div>

{#if showModal}
  <div
    class="modal d-block alturaTotal"
    tabindex="-1"
    aria-labelledby="dataModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dataModalLabel">Selecione os dados</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            on:click={closeModal}
          ></button>
        </div>
        <div class="modal-body" >
          <!-- Botões para alternar entre modos -->
          <div class="mb-2">
            <button
              class="btn {modo === 'lista' ? 'btn-primary' : 'btn-secondary'}"
              on:click={() => switchMode("lista")}
            >
              Modo Lista
            </button>
            <button
              class="btn {modo === 'texto_livre'
                ? 'btn-primary'
                : 'btn-secondary'}"
              on:click={() => switchMode("texto_livre")}
            >
              Modo Texto Livre
            </button>
          </div>

          {#if modo === "lista"}
            <!-- Exibe a lista normalmente -->
            <div class="d-flex align-items-center w-100 largura p-3">
              <input
                class="flex-grow-1"
                type="text"
                placeholder="Pesquisar..."
                bind:value={termo_pesquisa}
                on:input={Pesquisar}
              />
              {#if !carregando}
                <i class="fas fa-search fa-lg search-icon"></i>
              {:else}
                <Loading {carregando} />
              {/if}
            </div>
            <div class="data-container " on:scroll={handleScroll}>
              {#each dados as dado, idx}
                <div
                  class="data-block {selectedRows.some(
                    (row) => row.id === dado.id,
                  )
                    ? 'selected'
                    : ''}"
                  on:click={() => toggleRowSelection(dado, idx)}
                  style="cursor: pointer;"
                >
                  {#each keys as key}
                    {#if !IgnorarId || (IgnorarId && key != "id")}
                      <div class="data-field">
                        <strong>{key}:</strong>
                        {@html dado[key]}
                      </div>
                    {/if}
                  {/each}
                </div>
              {/each}
            </div>
          {:else if modo === "texto_livre"}
            <!-- Modo texto livre -->
            <textarea
              class="form-control"
              rows="10"
              bind:value={textoLivre}
              placeholder="Digite seu texto livre aqui..."
            ></textarea>
            <div class="mt-2">
             <input
                type="text"
                class="form-control mt-2"
                placeholder="Observação (opcional)"
                bind:value={obs}
              />
              <label>
                <input type="checkbox" bind:checked={salvarEmLista} />
                Salvar em lista
              </label>
              <input
                type="text"
                class="form-control mt-2"
                placeholder="Título"
                bind:value={tituloTextoLivre}
              />
            </div>
          {/if}
        </div>
        <div class="modal-footer">
          {#if modo === "texto_livre"}
            <button
              type="button"
              class="btn btn-primary"
              on:click={confirmarTextoLivre}
            >
              Confirmar
            </button>
          {/if}
          {#if modo === "lista"}
            <button
              type="button"
              class="btn btn-secondary"
              on:click={clearSelectedRows}
            >
              Limpar Seleções
            </button>
            <button
              type="button"
              class="btn btn-primary"
              on:click={() => ConfirmarLista()}
            >
              Confirmar
            </button>
          {/if}
          <button type="button" class="btn btn-secondary" on:click={closeModal}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .selected-rows-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .data-container {
    height: 300px;
    overflow-y: auto;
  }

  .data-block {
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .data-block.selected {
    background-color: #e9ecef;
  }

  .data-field {
    margin-bottom: 5px;
  }

  .btn-primary {
    background-color: #007bff;
    border: none;
  }

  .btn-secondary {
    background-color: #6c757d;
    border: none;
  }

  .btn-close {
    background: none;
    border: none;
  }

  .search-icon {
    margin-left: 10px;
  }

  .largura {
    width: 100%;
  }

  .disabled-input {
    cursor: not-allowed;
  }
  .alturaTotal{
    height: 800px;
  }
</style>
